import {RowProperties} from 'notebook/tables/constants/RowConstants';
import {
  computeHasUnsubmittedChanges,
  computeIsRowOutdated,
  computeIsTableRowTombstoned,
  computeTombstoneReasonTooltipForRow,
} from 'notebook/tables/store/logic/TableRowStatusLogic';
import {TableModel} from 'notebook/tables/store/models/TableModel';
import {createDebuggableSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {
  createTableEditableStoreStructuredSelector,
  TableEditableStore,
} from 'notebook/tables/store/TableStore';

export function createRowStatusSelector(
  tableSelector: (store: TableEditableStore) => TableModel,
  rowIndex: number
): (store: TableEditableStore) => RowProperties {
  return createTableEditableStoreStructuredSelector(
    {
      hasErrors: (store) => store.volatileProps.errorRows?.[rowIndex] === true,
      hasWarnings: (store) => store.volatileProps.warningRows?.[rowIndex] === true,
      hasUnsubmittedChanges: (store) => {
        const tableModel = tableSelector(store);
        return computeHasUnsubmittedChanges(
          store.volatileProps.table,
          rowIndex,
          tableModel.context.isConfigTable
        );
      },
      isOutdated: (store) => computeIsRowOutdated(store.volatileProps.staleRows, rowIndex),
      archivePurpose: (store) => store.volatileProps.table.rowData?.[rowIndex]?.uiData?.archivePurpose,
      isTombstoned: (store) => computeIsTableRowTombstoned(store.volatileProps.table, rowIndex),
      tombstoneReasonTooltip: (store) =>
        computeTombstoneReasonTooltipForRow(store.volatileProps.table, rowIndex),
      unsubmittedChangesTooltip: (store) =>
        store.volatileProps.table.rowData?.[rowIndex]?.uiData?.unsubmittedChangesTooltip,
    },
    createDebuggableSelector.withTypes<TableEditableStore>()
  );
}
